<template>
  <div>
    <b-form-input
      :id="context.id"
      v-model="timestamp"
      readonly
      :placeholder="$t('custom_forms.generate_timestamp')"
      class="cursor-pointer"
      @click="generateTimestamp"
    />
  </div>
</template>

<script>
import { ref, onMounted, watch } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    context: Object
  },
  setup(props, { emit }) {
    const timestamp = ref('');
    const isDisabled = ref(false);
    onMounted(() => {
      isDisabled.value = props.context.attributes.disabled ?? false;
      timestamp.value = props.context.model
    });

    watch(
      () => props.context.attributes.disabled,
      (newValue, oldValue) => {
        isDisabled.value = props.context.attributes.disabled ?? false;
      },
      { immediate: true }
    );

    function generateTimestamp() {
      if(isDisabled.value) return;
      const now = new Date();
      const DD = String(now.getDate()).padStart(2, '0');
      const MM = String(now.getMonth() + 1).padStart(2, '0');
      const AAAA = now.getFullYear();
      const hh = String(now.getHours()).padStart(2, '0');
      const mm = String(now.getMinutes()).padStart(2, '0');

      timestamp.value = `${DD}/${MM}/${AAAA} ${hh}:${mm}`;
      props.context.model = timestamp.value;
    }

    return {
      isDisabled,
      timestamp,
      generateTimestamp
    }
  }
}
</script>
